"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToAggregatedStockFromBackend = exports.convertToAggregatedStock = exports.computeAggregatedStock = exports.computePrices = exports.updateAggregatedLocations = exports.getPlaysetCoefficient = exports.generatePTProductSku = exports.convertPTInvArtToInventoryArticleLean = exports.convertPTInventoryArticleToPartialArticle = exports.convertPTInventoryArticleToInventoryArticle = exports.getStockIndexedByMkmIdProduct = exports.getSimilarArticle = exports.getArticlesDistanceFields = exports.commentSuggestsTaxation = exports.getPricesMapForeachInventoryArticle = exports.populatePricesInMap = exports.generateArticleKey = exports.isSingle = exports.STOCK_TYPES = exports.getEarliestTime = exports.getNextMonthDate = exports.getDateYYYYMMDD = exports.getYesterday = exports.orderContainsSealed = exports.hasUnresolvedIssues = exports.hasIssues = exports.getIssues = exports.getAllArticleIssues = exports.getOrderIssues = exports.getOrderTrackingNumber = exports.isValidDate = exports.getPaidOrdersId = exports.getOrderState = exports.escapeDoubleQuotes = exports.getAvailableQuantityNetOfPickedAndWithIssues = exports.getDisplayLocationName = exports.getStockMapFromStock = exports.getLastDate = exports.getGameFromId = exports.stripBrandingComment = exports.getBrandedComment = exports.BRANDING_COMMENT_V3 = exports.BRANDING_COMMENT_V2 = exports.BRANDING_COMMENT_V1 = exports.hasStartedPricing = exports.backfillMissingPricingStrategyTargets = exports.buildAvg30BuyStrategy = exports.AVG30_BUY_STRATEGY_ID = exports.roundTo2Decimals = exports.sleep = void 0;
exports.isInventoryStale = exports.GetUserRequest = exports.EndFixedPriceItemRequest = exports.AddFixedPriceItemRequest = exports.BulkDataExchangeRequestsClosing = exports.BulkDataExchangeRequestsOpening = exports.baseXmlHeader = exports.getArticleIdentityKey = exports.getIdentityKeyFromFields = exports.computeSubscriptionGaps = exports.normalizeCsvReportHistory = exports.normalizePurchase = exports.normalizePurchaseEvent = exports.normalizeSeller = exports.toPurchaseEventPayload = exports.getFilteredStockStatistics = exports.groupByPtArticle = exports.toSlimInventoryArticleList = exports.toSlimInventoryArticle = exports.extractFinishTypeFlags = exports.getPtAttributesFromPlainCardmarketArticle = exports.getPtAttributesFromCardmarketArticleAttributes = exports.checkCardmarketStockForV2Migration = exports.gameFromStockFileName = exports.parsePokemonFinishType = exports.parsePtStructuredComment = exports.needsGradeCompletion = exports.normalizeScaleGrade = exports.UNKNOWN_GRADE_VALUE = exports.commentSuggestsUsEdition = exports.getFinishTypeString = exports.getFinishTypeNumber = exports.mapBackendCountryEditionToInternal = exports.mapBackendFinishAttributeToInternal = exports.toEndOfInterval = exports.parseLocalDate = exports.getNDaysAgo = exports.getNMonthsAgo = exports.formatDateToYYYYMMDD = exports.convertInventoryArticleToCardTraderStockToSave = exports.mergeReconciledArticles = exports.computeDiffs = void 0;
var lodash_1 = __importDefault(require("lodash"));
var types_1 = require("types");
var Article_1 = require("./Article");
var constants_1 = require("./constants");
var gameMetaData_1 = require("./gameMetaData");
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.sleep = sleep;
var roundTo2Decimals = function (number) {
    return Math.round(number * 100) / 100;
};
exports.roundTo2Decimals = roundTo2Decimals;
exports.AVG30_BUY_STRATEGY_ID = 'avg30buy';
// Empty bulk settings per supported game, used by the default buy strategy.
// Game ids are hardcoded literals (not `IdGame.*`) because lib.ts and types.ts form a
// circular import, so `IdGame` resolves to `undefined` here at runtime — same reason the
// target below is the literal 'buyPrice'.
// Magic=1, Yugioh=3, Pokemon=6, Vanguard=8, FF=9, WS=10, DBS=13, FAB=16, Digimon=17, OnePiece=18
var emptyBuyStrategyBulkSettings = {
    1: '',
    3: '',
    6: '',
    8: '',
    9: '',
    10: '',
    13: '',
    16: '',
    17: '',
    18: '',
};
/**
 * Default buy pricing strategy: AVG30 price guide at 60% of market price (i.e. 40% below
 * market). Seeded on user creation, when taxation is enabled, and by the v1→v2 backfill.
 */
var buildAvg30BuyStrategy = function () {
    return ({
        _id: exports.AVG30_BUY_STRATEGY_ID,
        base: {
            kind: 'priceGuide',
            tactic: { parameter: 'AVG30' },
        },
        modifier: {
            kind: 'percent',
            value: 60,
        },
        name: 'AVG30 -40%',
        bulkSettingsId: emptyBuyStrategyBulkSettings,
        // literal instead of `PriceStategyTarget.buyPrice` — see the circular-import note above
        target: 'buyPrice',
    });
};
exports.buildAvg30BuyStrategy = buildAvg30BuyStrategy;
/**
 * Ensures a user's pricing strategies are complete and visible in v2:
 *  - sets `target: 'sellPrice'` on every strategy lacking it (v1-seeded strategies had no
 *    `target`; without it they are filtered out of the pricing/taxation UI and become
 *    invisible);
 *  - adds the default AVG30 buy strategy when the user has none.
 * Covers both brand-new users (only the default strategies) and long-standing v1 users
 * (many custom strategies) moving to v2. Mutates the array in place and returns `true` if
 * anything changed, so the caller knows whether it needs to persist (markModified / save).
 */
var backfillMissingPricingStrategyTargets = function (pricingStrategies) {
    if (pricingStrategies === void 0) { pricingStrategies = []; }
    var changed = false;
    pricingStrategies.forEach(function (strategy) {
        if (strategy.target == null) {
            // Use the literal value (=== PriceStategyTarget.sellPrice) instead of dereferencing
            // the enum object: lib.ts and types.ts form a circular import, so at runtime
            // `PriceStategyTarget` resolves to `undefined` here — both in the client bundle and
            // in the compiled CJS `dist` used by the backend.
            strategy.target = 'sellPrice';
            changed = true;
        }
    });
    if (!pricingStrategies.some(function (strategy) { return strategy._id === exports.AVG30_BUY_STRATEGY_ID; })) {
        pricingStrategies.push((0, exports.buildAvg30BuyStrategy)());
        changed = true;
    }
    return changed;
};
exports.backfillMissingPricingStrategyTargets = backfillMissingPricingStrategyTargets;
// Whether the user has already done some pricing work of their own: a competitor, a strategy or a
// pricing program. What every account is seeded with does not count.
var hasStartedPricing = function (user) {
    var _a, _b, _c;
    var seededStrategyIds = __spreadArray(__spreadArray([], constants_1.DEFAULT_PRICING_STRATEGY_IDS, true), [exports.AVG30_BUY_STRATEGY_ID], false);
    return (((_a = user.competitors) !== null && _a !== void 0 ? _a : []).some(function (c) { return !constants_1.DEFAULT_COMPETITOR_IDS.includes(c._id); }) ||
        ((_b = user.pricingStrategies) !== null && _b !== void 0 ? _b : []).some(function (s) { return !seededStrategyIds.includes(s._id); }) ||
        ((_c = user.pricingPlans) !== null && _c !== void 0 ? _c : []).length > 0);
};
exports.hasStartedPricing = hasStartedPricing;
exports.BRANDING_COMMENT_V1 = 'listed with tcgpt.app';
exports.BRANDING_COMMENT_V2 = 'listed with TCGPowerTools(.com)';
exports.BRANDING_COMMENT_V3 = '';
var getBrandedComment = function (comment) {
    return comment;
};
exports.getBrandedComment = getBrandedComment;
var stripBrandingComment = function (comment) {
    if (comment.includes(exports.BRANDING_COMMENT_V1)) {
        comment = comment
            .replace(" | ".concat(exports.BRANDING_COMMENT_V1), '')
            .replace("".concat(exports.BRANDING_COMMENT_V1, " | "), '');
    }
    if (comment.includes(exports.BRANDING_COMMENT_V2)) {
        comment = comment
            .replace(" | ".concat(exports.BRANDING_COMMENT_V2), '')
            .replace("".concat(exports.BRANDING_COMMENT_V2, " | "), '');
    }
    return comment;
};
exports.stripBrandingComment = stripBrandingComment;
var getGameFromId = function (idGame) {
    var inverseGameMap = {
        99: 'Unknown',
        1: 'Magic',
        3: 'Yugioh',
        6: 'Pokemon',
        8: 'Vanguard',
        9: 'FF',
        13: 'DBS',
        10: 'WS',
        16: 'FAB',
        17: 'Digimon',
        18: 'OnePiece',
        19: 'Lorcana',
        20: 'BSS',
        21: 'SWU',
        22: 'Riftbound',
        23: 'Cyberpunk',
        24: 'Gundam',
        25: 'Sorcery',
    };
    return inverseGameMap[idGame];
};
exports.getGameFromId = getGameFromId;
var getLastDate = function (state) {
    if (state.dateReceived) {
        return state.dateReceived;
    }
    if (state.dateSent) {
        return state.dateSent;
    }
    if (state.datePaid) {
        return state.datePaid;
    }
    return state.dateBought;
};
exports.getLastDate = getLastDate;
var getStockMapFromStock = function (inputStock) {
    var stockMap = {};
    inputStock.forEach(function (article) {
        var cardmarketProductId = article.card._id;
        if (!stockMap[cardmarketProductId]) {
            stockMap[cardmarketProductId] = [];
        }
        article.rendered = true;
        stockMap[cardmarketProductId].push(new Article_1.InventoryArticle(article));
    });
    return stockMap;
};
exports.getStockMapFromStock = getStockMapFromStock;
/**
 *
 * when a location name is an empty string or an alphanumeric string used internally, convert this name into a more user-readable label.
 * otherwise return the location name set by user
 */
var getDisplayLocationName = function (locationName) {
    if (locationName === undefined || locationName === null)
        return '';
    if (locationName === '')
        return 'Default';
    if (locationName.toLowerCase().startsWith('unknown')) {
        return 'Unknown';
    }
    return locationName;
};
exports.getDisplayLocationName = getDisplayLocationName;
var getAvailableQuantityNetOfPickedAndWithIssues = function (location) {
    if (location.totalPickedQuantity === undefined)
        location.totalPickedQuantity = 0;
    if (location.totalQuantityWithIssues === undefined)
        location.totalQuantityWithIssues = 0;
    return location.quantity - (location.totalPickedQuantity + location.totalQuantityWithIssues);
};
exports.getAvailableQuantityNetOfPickedAndWithIssues = getAvailableQuantityNetOfPickedAndWithIssues;
var escapeDoubleQuotes = function (value) {
    return (value || '').replace(/"/g, '""');
};
exports.escapeDoubleQuotes = escapeDoubleQuotes;
var getOrderState = function (order) {
    var _a;
    return (_a = order.state) === null || _a === void 0 ? void 0 : _a.state;
};
exports.getOrderState = getOrderState;
var getPaidOrdersId = function (orders) {
    // const MAX_NUM_PAID_ORDERS = 99
    var paidOrders = orders.filter(function (o) { return (0, exports.getOrderState)(o) === 'paid'; });
    // sort paid orders by datePaid (ascending order)
    paidOrders.sort(function (a, b) {
        if (a.state.datePaid && b.state.datePaid) {
            return a.state.datePaid > b.state.datePaid ? 1 : -1;
        }
        else {
            return 0;
        }
    });
    // return only the first MAX_NUM_PAID_ORDERS
    // paidOrders.splice(MAX_NUM_PAID_ORDERS)
    var paidOrdersId = paidOrders.map(function (o) { return o.ptOrderId; });
    return paidOrdersId;
};
exports.getPaidOrdersId = getPaidOrdersId;
var isValidDate = function (value) {
    var dateObject = new Date(value);
    return !isNaN(dateObject.getTime());
};
exports.isValidDate = isValidDate;
var getOrderTrackingNumber = function (order) {
    var _a, _b;
    return (_b = (_a = order.shipping) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : '';
};
exports.getOrderTrackingNumber = getOrderTrackingNumber;
var getOrderIssues = function (order) {
    return order.issues || [];
};
exports.getOrderIssues = getOrderIssues;
var getAllArticleIssues = function (order) {
    var _a;
    var issues = [];
    (_a = order.articles) === null || _a === void 0 ? void 0 : _a.map(function (a) {
        if (a.issues)
            issues = issues.concat(a.issues);
    });
    return issues || [];
};
exports.getAllArticleIssues = getAllArticleIssues;
var getIssues = function (order) {
    return (0, exports.getOrderIssues)(order).concat((0, exports.getAllArticleIssues)(order));
};
exports.getIssues = getIssues;
var hasIssues = function (order) {
    var hasOrderIssues = (0, exports.getOrderIssues)(order).length > 0;
    var hasArticleIssues = (0, exports.getAllArticleIssues)(order).length > 0;
    return hasOrderIssues || hasArticleIssues || false;
};
exports.hasIssues = hasIssues;
var hasUnresolvedIssues = function (order) {
    var orderIssues = (0, exports.getOrderIssues)(order);
    var articleIssues = (0, exports.getAllArticleIssues)(order);
    var hasUnresolvedIssues = false;
    if (orderIssues) {
        orderIssues.forEach(function (i) {
            if (!i.solved) {
                hasUnresolvedIssues = true;
                return;
            }
        });
    }
    if (articleIssues) {
        articleIssues.forEach(function (i) {
            if (!i.solved) {
                hasUnresolvedIssues = true;
                return;
            }
        });
    }
    return hasUnresolvedIssues;
};
exports.hasUnresolvedIssues = hasUnresolvedIssues;
var orderContainsSealed = function (order) {
    var sealedCategories = order.articleCategories.filter(function (c) { return !c.includes('Single') && c.match(/[a-zA-z]+/g); });
    return sealedCategories.length > 0;
};
exports.orderContainsSealed = orderContainsSealed;
var getYesterday = function () {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
};
exports.getYesterday = getYesterday;
var getDateYYYYMMDD = function (date) {
    var isoDate = date.toISOString();
    return isoDate.split('T')[0];
};
exports.getDateYYYYMMDD = getDateYYYYMMDD;
var getNextMonthDate = function (date) {
    // Get the current year, month, and day
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    // Create a new date object for the same year and the next month
    var nextMonthDate = new Date(date.setMonth(month + 1));
    // If the resulting month is greater than 11 (December), then it's a new year
    // and we need to set the year to the next year and the month to January (0)
    if (nextMonthDate.getMonth() > 11) {
        nextMonthDate.setFullYear(year + 1);
        nextMonthDate.setMonth(0);
    }
    // Get the last day of the month for the year and month we're interested in
    var lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    // If the original day is greater than the last day of the month, set it to the last day of the month
    if (day > lastDayOfMonth) {
        nextMonthDate.setDate(lastDayOfMonth);
    }
    else {
        nextMonthDate.setDate(day);
    }
    return nextMonthDate;
};
exports.getNextMonthDate = getNextMonthDate;
var getEarliestTime = function (date1, date2) {
    var hours1 = date1.getUTCHours();
    var minutes1 = date1.getMinutes();
    var hours2 = date2.getUTCHours();
    var minutes2 = date2.getMinutes();
    if (hours1 > hours2 || (hours1 === hours2 && minutes1 > minutes2)) {
        return date2;
    }
    else {
        return date1;
    }
};
exports.getEarliestTime = getEarliestTime;
exports.STOCK_TYPES = {
    SINGLES: 'singles',
    SEALED: 'sealed',
};
var isSingle = function (item) {
    var _a;
    return (_a = item.categoryName) === null || _a === void 0 ? void 0 : _a.includes('Single');
};
exports.isSingle = isSingle;
var generateArticleKey = function (article) {
    var keyAttributes = [];
    if (article instanceof Article_1.AggregatedInventoryArticle) {
        keyAttributes = [
            article.card.idGame,
            article.card.set,
            article.idProduct,
            article.idLanguage,
            article.condition,
            article.isSigned,
            article.isFirstEd,
            article.finishType,
            article.countryEdition,
            article.gradingCompany,
            article.grade,
        ];
    }
    else if (article instanceof Article_1.InventoryArticle) {
        keyAttributes = [
            article.attributes[3],
            article.attributes[1],
            article.attributes[2],
            article.attributes[6],
            article.attributes[7],
            article.attributes[8],
            article.attributes[11],
            article.attributes[15],
            article.attributes[14],
            article.attributes[12],
            article.attributes[13], // grade
        ];
    }
    return keyAttributes.join('-');
};
exports.generateArticleKey = generateArticleKey;
/**
 *
 * populates the price list. This is all the prices in the InventoryPricesMap items
 */
var populatePricesInMap = function (pricesMap) {
    Object.keys(pricesMap).forEach(function (key) {
        var entry = pricesMap[key];
        var listOfPrices = [];
        entry.articles.forEach(function (article) {
            if (listOfPrices.includes(article.price)) {
                return;
            }
            listOfPrices.push(article.price);
        });
        listOfPrices.sort(function (a, b) { return a - b; });
        entry.prices = listOfPrices;
    });
    return pricesMap;
};
exports.populatePricesInMap = populatePricesInMap;
/**
 *
 * given a stock (list of InventoryArticle) creates a map following the InventoryPricesMap interface where the key
 * is the list of attributes that distinguish the InventoryArticle, the value is an object composed of the list
 * of corresponding inventory articles, and the prices present in this list of articles.
 * This map is completed in two steps: first the key-articles object is created with the array of empty prices,
 * then the array of prices is completed.
 * Finally the complete object with all its information is returned
 */
var getPricesMapForeachInventoryArticle = function (inventoryArticles) {
    var pricesMap = {};
    inventoryArticles.forEach(function (article) {
        var key = (0, exports.generateArticleKey)(article);
        if (!pricesMap[key]) {
            // Create a new entry with an array of items and an empty array of prices
            pricesMap[key] = {
                articles: [article],
                prices: [],
            };
        }
        else {
            pricesMap[key].articles.push(article);
        }
    });
    var updatedMapWithPrices = (0, exports.populatePricesInMap)(pricesMap);
    return updatedMapWithPrices;
};
exports.getPricesMapForeachInventoryArticle = getPricesMapForeachInventoryArticle;
// Keywords German sellers use for the margin (Diff) or standard (MWST) VAT scheme.
var commentSuggestsTaxation = function (comment) {
    return !!comment && (comment.includes('Diff') || comment.includes('MWST'));
};
exports.commentSuggestsTaxation = commentSuggestsTaxation;
/**
 * returns the distance between two article, which is the number of fields that
 * differ between them
 */
var getArticlesDistanceFields = function (a, b) {
    var conflictingFields = [];
    if (a.quantity !== b.quantity) {
        conflictingFields.push('quantity');
    }
    if (a.condition !== b.condition) {
        conflictingFields.push('condition');
    }
    if (a.idLanguage !== b.idLanguage) {
        conflictingFields.push('language');
    }
    if (a.isSigned !== b.isSigned) {
        conflictingFields.push('signed');
    }
    if (a.finishType !== b.finishType) {
        conflictingFields.push('finishType');
    }
    if (a.isFirstEd !== b.isFirstEd) {
        conflictingFields.push('firstEd');
    }
    if (a.countryEdition !== b.countryEdition) {
        conflictingFields.push('countryEdition');
    }
    if (a.gradingCompany !== b.gradingCompany) {
        conflictingFields.push('gradingCompany');
    }
    if (a.grade !== b.grade) {
        conflictingFields.push('grade');
    }
    return conflictingFields;
};
exports.getArticlesDistanceFields = getArticlesDistanceFields;
var getSimilarArticle = function (article, list) {
    var similarArticle = null;
    var distanceFields = [];
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var item = list_1[_i];
        if (item.isProcessed) {
            continue;
        }
        distanceFields = (0, exports.getArticlesDistanceFields)(article, item);
        if (distanceFields.length === 1 && distanceFields[0] === 'quantity') {
            similarArticle = item;
            break;
        }
    }
    return { similarArticle: similarArticle, distanceFields: distanceFields };
};
exports.getSimilarArticle = getSimilarArticle;
var getStockIndexedByMkmIdProduct = function (stock) {
    var stockIndexedByMkmIdProduct = stock.reduce(function (map, article) {
        var _a;
        var idProduct = article.idProduct;
        if (map.has(idProduct)) {
            // If the key already exists in the map, append the data object to the existing array
            (_a = map.get(idProduct)) === null || _a === void 0 ? void 0 : _a.push(article);
        }
        else {
            // If the key does not exist in the map, create a new array with the data object
            map.set(idProduct, [article]);
        }
        return map;
    }, new Map());
    return stockIndexedByMkmIdProduct;
};
exports.getStockIndexedByMkmIdProduct = getStockIndexedByMkmIdProduct;
var convertPTInventoryArticleToInventoryArticle = function (cardDataMap, ptInventoryArticle) {
    var _a, _b, _c;
    if (!ptInventoryArticle.ptProduct.mkmProduct) {
        throw new Error('ptInventoryArticle does not have mkmProduct');
    }
    var mkmProductId = Number(ptInventoryArticle.ptProduct.mkmProductId);
    var baseCard = cardDataMap.get(mkmProductId);
    if (!baseCard) {
        return null;
    }
    return new Article_1.RichArticle({
        card: baseCard.toPlainObject(),
        idLanguage: ptInventoryArticle.ptProduct.idLanguage,
        condition: ptInventoryArticle.ptProduct.condition,
        // we don't want to count reserved quantity in the total quantity when
        // computing the aggregated stock, it will be used for syncing with Cardmarket
        quantity: ptInventoryArticle.quantity - ptInventoryArticle.reservedQuantity,
        isSigned: ptInventoryArticle.ptProduct.isSigned,
        isFirstEd: ptInventoryArticle.ptProduct.isFirstEd,
        finishType: constants_1.FINISH_TYPES_CONVERSIONS.find(function (entry) { return entry.code === ptInventoryArticle.ptProduct.finishType; }).label,
        countryEdition: constants_1.countryEditionMap.find(function (entry) { return entry.code === ptInventoryArticle.ptProduct.countryEdition; }).value,
        grade: (_a = ptInventoryArticle.ptProduct.grade) !== null && _a !== void 0 ? _a : undefined,
        gradingCompany: (_c = (_b = constants_1.GRADING_COMPANY_LABELS.find(function (entry) { return entry.code === ptInventoryArticle.ptProduct.gradingCompany; })) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : undefined,
    });
};
exports.convertPTInventoryArticleToInventoryArticle = convertPTInventoryArticleToInventoryArticle;
var convertPTInventoryArticleToPartialArticle = function (article) {
    var _a, _b, _c, _d;
    var attributes = [
        article.quantity,
        article.ptProduct.condition,
        article.ptProduct.idLanguage,
        article.ptProduct.mkmProductId,
        article.baseSellPrice,
        article.comment || '',
        false,
        article.ptProduct.isSigned,
        article.ptProduct.isFirstEd,
        '',
        null,
        false,
        (_b = (_a = constants_1.GRADING_COMPANY_LABELS.find(function (entry) { return entry.code === article.ptProduct.gradingCompany; })) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : undefined,
        article.ptProduct.grade,
        (_d = (_c = constants_1.countryEditionMap.find(function (entry) { return entry.code === article.ptProduct.countryEdition; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : constants_1.CountryEdition.Regular,
        (0, exports.mapBackendFinishAttributeToInternal)(article.ptProduct.finishType),
        undefined,
    ];
    return new Article_1.Article({ attributes: attributes });
};
exports.convertPTInventoryArticleToPartialArticle = convertPTInventoryArticleToPartialArticle;
var convertPTInvArtToInventoryArticleLean = function (card, ptInventoryArticle) {
    var _a, _b, _c;
    if (!ptInventoryArticle.ptProduct.mkmProduct) {
        throw new Error('ptInventoryArticle does not have mkmProduct');
    }
    var baseCard = card;
    if (!baseCard) {
        return null;
    }
    return new Article_1.RichArticle({
        card: baseCard.toPlainObject(),
        idLanguage: ptInventoryArticle.ptProduct.idLanguage,
        condition: ptInventoryArticle.ptProduct.condition,
        // we don't want to count reserved quantity in the total quantity when
        // computing the aggregated stock
        quantity: ptInventoryArticle.quantity - ptInventoryArticle.reservedQuantity,
        isSigned: ptInventoryArticle.ptProduct.isSigned,
        isFirstEd: ptInventoryArticle.ptProduct.isFirstEd,
        finishType: constants_1.FINISH_TYPES_CONVERSIONS.find(function (entry) { return entry.code === ptInventoryArticle.ptProduct.finishType; }).label,
        countryEdition: constants_1.countryEditionMap.find(function (entry) { return entry.code === ptInventoryArticle.ptProduct.countryEdition; }).value,
        grade: (_a = ptInventoryArticle.ptProduct.grade) !== null && _a !== void 0 ? _a : undefined,
        gradingCompany: (_c = (_b = constants_1.GRADING_COMPANY_LABELS.find(function (entry) { return entry.code === ptInventoryArticle.ptProduct.gradingCompany; })) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : undefined,
    });
};
exports.convertPTInvArtToInventoryArticleLean = convertPTInvArtToInventoryArticleLean;
var getCardDataMap = function (cardData) {
    var cardDataMap = new Map();
    cardData.forEach(function (card) {
        cardDataMap.set(card._id, card);
    });
    return cardDataMap;
};
var generatePTProductSku = function (_a) {
    var idGame = _a.idGame, expansionCode = _a.expansionCode, cn = _a.cn, condition = _a.condition, idLanguage = _a.idLanguage, isFoil = _a.isFoil, isRainbowFoil = _a.isRainbowFoil, isColdFoil = _a.isColdFoil, isReverseHolo = _a.isReverseHolo, isSigned = _a.isSigned, isFirstEd = _a.isFirstEd;
    var ptProductSku = '';
    ptProductSku = "".concat(idGame, "_").concat(expansionCode, "_").concat(cn, "_").concat(condition, "_").concat(idLanguage);
    if (isFoil) {
        ptProductSku += '_F';
    }
    if (isRainbowFoil) {
        ptProductSku += '_Rf';
    }
    if (isColdFoil) {
        ptProductSku += '_Cf';
    }
    if (isReverseHolo) {
        ptProductSku += '_Rh';
    }
    if (isSigned) {
        ptProductSku += '_1';
    }
    if (isFirstEd) {
        ptProductSku += '_S';
    }
    return ptProductSku;
};
exports.generatePTProductSku = generatePTProductSku;
var getPlaysetCoefficient = function (idGame) {
    var game = (0, gameMetaData_1.getGameMetaData)(idGame);
    return game.playsetCount || 1;
};
exports.getPlaysetCoefficient = getPlaysetCoefficient;
var updateAggregatedLocations = function (aggregatedArticle, location, quantity) {
    var _a, _b;
    var foundLocation = false;
    (_a = aggregatedArticle.locations) === null || _a === void 0 ? void 0 : _a.forEach(function (aggregatedLocation) {
        if (aggregatedLocation.location === location) {
            aggregatedLocation.quantity += quantity;
            foundLocation = true;
        }
    });
    if (!foundLocation) {
        (_b = aggregatedArticle.locations) === null || _b === void 0 ? void 0 : _b.push({
            location: location,
            quantity: quantity,
        });
    }
};
exports.updateAggregatedLocations = updateAggregatedLocations;
var computePrices = function (prices) {
    var minPrice = Math.min.apply(Math, prices);
    var avgPrice = prices.reduce(function (a, b) { return a + b; }, 0) / prices.length;
    var maxPrice = Math.max.apply(Math, prices);
    return {
        minPrice: Number.parseFloat(minPrice.toFixed(2)),
        avgPrice: Number.parseFloat(avgPrice.toFixed(2)),
        maxPrice: Number.parseFloat(maxPrice.toFixed(2)),
    };
};
exports.computePrices = computePrices;
var computeAggregatedStock = function (stock, articlesInShoppingCarts) {
    console.log("converting cm stock to aggregated stock");
    var start = new Date().getTime();
    var newAggregatedStock = [];
    var mapAggregatedStock = new Map();
    stock.forEach(function (article) {
        var quantity = article.quantity, price = article.price;
        var ptQuantity = article.isPlayset
            ? quantity * (0, exports.getPlaysetCoefficient)(article.card.idGame || types_1.IdGame.Magic)
            : quantity;
        article.quantity = ptQuantity;
        // const aggregatedArticle = findAggregatedInventoryArticle(newAggregatedStock, article)
        // const articleKey = `${article.idProduct}-${article.idLanguage}-${article.condition}-${article.isSigned}-${article.isFirstEd}-${article.finishType}-${article.countryEdition}`
        var articleKey = (0, exports.generateArticleKey)(article);
        var aggregatedArticle = mapAggregatedStock.get(articleKey);
        if (aggregatedArticle) {
            // update already existing aggregated article
            aggregatedArticle.quantity += ptQuantity;
            if (!aggregatedArticle.prices.includes(price)) {
                aggregatedArticle.prices.push(price);
            }
            (0, exports.updateAggregatedLocations)(aggregatedArticle, article.comment, ptQuantity);
        }
        else {
            // create and set new aggregated article
            var newAggregatedArticle = new Article_1.AggregatedInventoryArticle({
                article: new Article_1.InventoryArticle(article.toPlainObject()),
                hasConflict: false,
                isSelectedForConflictResolution: false,
                isProcessed: false,
                conflictFields: [],
                minPrice: price,
                avgPrice: price,
                maxPrice: price,
                prices: [price],
                selectedPrice: price,
                source: constants_1.INVENTORY_TRANSACTION_SOURCES.CARDMARKET,
                locations: [
                    {
                        location: article.comment,
                        quantity: ptQuantity,
                    },
                ],
            });
            newAggregatedStock.push(newAggregatedArticle);
            mapAggregatedStock.set(articleKey, newAggregatedArticle);
        }
    });
    // integrate articles in shopping carts, if any
    if (articlesInShoppingCarts) {
        articlesInShoppingCarts.forEach(function (article) {
            var quantity = article.quantity, price = article.price;
            var ptQuantity = article.isPlayset
                ? quantity * (0, exports.getPlaysetCoefficient)(article.card.idGame || types_1.IdGame.Magic)
                : quantity;
            article.quantity = ptQuantity;
            // const articleKey = `${article.idProduct}-${article.idLanguage}-${article.condition}-${article.isSigned}-${article.isFirstEd}-${article.finishType}-${article.countryEdition}`
            var articleKey = (0, exports.generateArticleKey)(article);
            var aggregatedArticle = mapAggregatedStock.get(articleKey);
            if (aggregatedArticle) {
                // update already existing aggregated article
                aggregatedArticle.quantity += ptQuantity;
                if (!aggregatedArticle.prices.includes(price)) {
                    aggregatedArticle.prices.push(price);
                }
                (0, exports.updateAggregatedLocations)(aggregatedArticle, article.comment, ptQuantity);
            }
            else {
                // create and set new aggregated article
                var newAggregatedArticle = new Article_1.AggregatedInventoryArticle({
                    article: new Article_1.InventoryArticle(article.toPlainObject()),
                    hasConflict: false,
                    isSelectedForConflictResolution: false,
                    isProcessed: false,
                    conflictFields: [],
                    minPrice: price,
                    avgPrice: price,
                    maxPrice: price,
                    prices: [price],
                    selectedPrice: price,
                    source: constants_1.INVENTORY_TRANSACTION_SOURCES.CARDMARKET,
                    locations: [
                        {
                            location: article.comment,
                            quantity: ptQuantity,
                        },
                    ],
                });
                newAggregatedStock.push(newAggregatedArticle);
                mapAggregatedStock.set(articleKey, newAggregatedArticle);
            }
        });
    }
    // pre-compute prices to show
    console.log("pre-computing prices");
    newAggregatedStock.forEach(function (aggregatedArticle) {
        var _a = (0, exports.computePrices)(aggregatedArticle.prices), minPrice = _a.minPrice, avgPrice = _a.avgPrice, maxPrice = _a.maxPrice;
        aggregatedArticle.minPrice = minPrice;
        aggregatedArticle.avgPrice = avgPrice;
        aggregatedArticle.maxPrice = maxPrice;
        aggregatedArticle.selectedPrice = avgPrice;
        if (!aggregatedArticle.prices.includes(avgPrice)) {
            aggregatedArticle.prices.push(avgPrice);
        }
        aggregatedArticle.prices.sort();
    });
    // sort article by avg price
    console.log("sorting articles by avg price");
    newAggregatedStock.sort(function (a, b) { return b.avgPrice - a.avgPrice; });
    var end = new Date().getTime();
    console.log("converting cm stock to aggregated stock took ".concat((end - start) / 1000, " seconds"));
    return newAggregatedStock;
};
exports.computeAggregatedStock = computeAggregatedStock;
var convertToAggregatedStock = function (cardData, stock) {
    console.log("converting pt stock to aggregated stock");
    var start = new Date().getTime();
    // switching from cardData array to map
    var cardDataMap = getCardDataMap(cardData);
    // aggregate multiple articles (in different locations) into the same object
    var articleMap = {};
    var stockCopy = lodash_1.default.cloneDeep(stock);
    stockCopy.forEach(function (article) {
        var _a;
        if (!articleMap[article._id]) {
            articleMap[article._id] = article;
        }
        else {
            articleMap[article._id].quantity += article.quantity;
            (_a = articleMap[article._id].locations).push.apply(_a, article.locations);
        }
    });
    // convert articleMap values to array
    var aggregatedStock = Object.values(articleMap);
    var newAggregatedStock = aggregatedStock
        .map(function (article) {
        var convertedArticle = (0, exports.convertPTInventoryArticleToInventoryArticle)(cardDataMap, article);
        if (!convertedArticle) {
            return null;
        }
        var newAggregatedArticle = new Article_1.AggregatedInventoryArticle({
            article: convertedArticle,
            hasConflict: false,
            isSelectedForConflictResolution: false,
            isProcessed: false,
            conflictFields: [],
            minPrice: article.baseSellPrice,
            avgPrice: article.baseSellPrice,
            maxPrice: article.baseSellPrice,
            prices: [article.baseSellPrice],
            selectedPrice: article.baseSellPrice,
            source: constants_1.INVENTORY_TRANSACTION_SOURCES.POWERTOOLS,
            locations: article.locations.map(function (location) {
                return {
                    location: location.name,
                    quantity: location.quantity,
                };
            }),
        });
        return newAggregatedArticle;
    })
        .filter(function (aggregatedArticle) { return aggregatedArticle !== null; });
    var end = new Date().getTime();
    console.log("converted pt stock to aggregated stock in ".concat((end - start) / 1000, " seconds"));
    return newAggregatedStock;
};
exports.convertToAggregatedStock = convertToAggregatedStock;
var convertToAggregatedStockFromBackend = function (productDict, stock) {
    console.log("converting pt stock to aggregated stock");
    var start = new Date().getTime();
    var articleMap = {};
    stock.forEach(function (article) {
        var _a;
        if (!articleMap[article._id]) {
            articleMap[article._id] = article;
        }
        else {
            articleMap[article._id].quantity += article.quantity;
            (_a = articleMap[article._id].locations).push.apply(_a, article.locations);
        }
    });
    // convert articleMap values to array
    stock = Object.values(articleMap);
    var newAggregatedStock = stock
        .map(function (article) {
        var workerCard = productDict[article.ptProduct.mkmProductId];
        var convertedArticle = (0, exports.convertPTInvArtToInventoryArticleLean)(workerCard, article);
        if (!convertedArticle) {
            return null;
        }
        var newAggregatedArticle = new Article_1.AggregatedInventoryArticle({
            article: convertedArticle,
            hasConflict: false,
            isSelectedForConflictResolution: false,
            isProcessed: false,
            conflictFields: [],
            minPrice: article.baseSellPrice,
            avgPrice: article.baseSellPrice,
            maxPrice: article.baseSellPrice,
            prices: [article.baseSellPrice],
            selectedPrice: article.baseSellPrice,
            source: constants_1.INVENTORY_TRANSACTION_SOURCES.POWERTOOLS,
        });
        return newAggregatedArticle;
    })
        .filter(function (aggregatedArticle) { return aggregatedArticle !== null; });
    var end = new Date().getTime();
    console.log("converted pt stock to aggregated stock in ".concat((end - start) / 1000, " seconds"));
    return newAggregatedStock;
};
exports.convertToAggregatedStockFromBackend = convertToAggregatedStockFromBackend;
var getPerfectMatchesBackend = function (leftData, rightData) {
    console.log("getPerfectMatchesBackend");
    var newLeftData = __spreadArray([], leftData, true);
    var newRightData = __spreadArray([], rightData, true);
    var newRightDataMap = new Map();
    newRightData.forEach(function (item, index) {
        var aggregatedArticleKey = (0, exports.generateArticleKey)(item);
        newRightDataMap.set("".concat(aggregatedArticleKey, "-").concat(item.quantity), index);
    });
    // compute common data
    var newCommonData = [];
    newLeftData.forEach(function (leftItem) {
        var aggregatedArticleKey = (0, exports.generateArticleKey)(leftItem);
        var key = "".concat(aggregatedArticleKey, "-").concat(leftItem.quantity);
        var rightItemIndex = newRightDataMap.get(key);
        if (rightItemIndex !== undefined) {
            newCommonData.push(leftItem);
            leftItem.isSelectedForConflictResolution = true;
            leftItem.isProcessed = true;
            newRightData[rightItemIndex].isProcessed = true;
        }
    });
    return { newLeftData: newLeftData, newRightData: newRightData, newCommonData: newCommonData };
};
var getPartialMatchesBackend = function (leftData, rightData, paddedLeftData, paddedRightData) {
    console.log("getPartialMatchesBackend");
    var newLeftData = __spreadArray([], leftData, true);
    var indexedRightData = (0, exports.getStockIndexedByMkmIdProduct)(rightData);
    var newNumConflicts = 0;
    newLeftData.forEach(function (leftItem) {
        var rightDataItems = indexedRightData.get(leftItem.idProduct);
        if (rightDataItems) {
            var _a = (0, exports.getSimilarArticle)(leftItem, rightDataItems), similarArticle = _a.similarArticle, distanceFields = _a.distanceFields;
            // if we find a similar article, we don't add it to the extra data but
            // we add the other articles from the rightDataItems to the extra data
            if (!similarArticle) {
                return;
            }
            leftItem.hasConflict = true;
            similarArticle.hasConflict = true;
            leftItem.conflictFields = distanceFields;
            similarArticle.conflictFields = distanceFields;
            paddedLeftData.push(leftItem);
            paddedRightData.push(similarArticle);
            newNumConflicts++;
            leftItem.isProcessed = true;
            similarArticle.isProcessed = true;
        }
    });
    return newNumConflicts;
};
var computeDiffs = function (currentAggregatedStock, incomingAggregatedStock) {
    var newPaddedLeftData = [];
    var newPaddedRightData = [];
    // compute common data
    var _a = getPerfectMatchesBackend(currentAggregatedStock, incomingAggregatedStock), newLeftData = _a.newLeftData, newRightData = _a.newRightData;
    var unprocessedLeftData = newLeftData.filter(function (item) { return !item.isProcessed; });
    var unprocessedRightData = newRightData.filter(function (item) { return !item.isProcessed; });
    // compute partial matches
    var numPartialMatches = getPartialMatchesBackend(unprocessedLeftData, unprocessedRightData, newPaddedLeftData, newPaddedRightData);
    // update unprocessed data: these are the articles present only on one side of the
    // comparison (so only on PowerTools or only on Cardmarket)
    unprocessedRightData = unprocessedRightData.filter(function (item) { return !item.isProcessed; });
    unprocessedLeftData = unprocessedLeftData.filter(function (item) { return !item.isProcessed; });
    return numPartialMatches + unprocessedLeftData.length + unprocessedRightData.length;
};
exports.computeDiffs = computeDiffs;
/**
 * The comments step hands back one article per group; the price step hands back
 * every listing. Each listing takes the choice made for its group, and a group
 * is taken once however many listings fell into it: the reconciled article
 * already carries all of their locations.
 */
var mergeReconciledArticles = function (articles, reconciled) {
    var byKey = new Map(reconciled.map(function (article) { return [(0, exports.generateArticleKey)(article), article]; }));
    var taken = new Set();
    return articles.flatMap(function (article) {
        var key = (0, exports.generateArticleKey)(article);
        var merged = byKey.get(key);
        if (merged === undefined)
            return [article];
        if (taken.has(key))
            return [];
        taken.add(key);
        return [merged];
    });
};
exports.mergeReconciledArticles = mergeReconciledArticles;
var convertInventoryArticleToCardTraderStockToSave = function (stock) {
    var ctData = [];
    stock.forEach(function (article) {
        var _a, _b;
        var newArticle = {
            ptProductId: (_a = article.ptProductId) !== null && _a !== void 0 ? _a : -1,
            comment: (_b = article.comment) !== null && _b !== void 0 ? _b : '',
            location: [],
            price: article.price,
        };
        article.locations.forEach(function (location) {
            newArticle.location = __spreadArray(__spreadArray([], newArticle.location, true), [
                { name: location.name, quantity: location.quantity },
            ], false);
        });
        ctData.push(newArticle);
    });
    return ctData;
};
exports.convertInventoryArticleToCardTraderStockToSave = convertInventoryArticleToCardTraderStockToSave;
var formatDateToYYYYMMDD = function (date) {
    var year = String(date.getFullYear()).padStart(4, '0'); // Pad so transient years (<1000) stay valid yyyy-MM-dd
    var month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    var day = String(date.getDate()).padStart(2, '0');
    // Create the formatted date string
    var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
    return formattedDate;
};
exports.formatDateToYYYYMMDD = formatDateToYYYYMMDD;
var getNMonthsAgo = function (n) {
    var date = new Date();
    date.setMonth(date.getMonth() - n);
    return date;
};
exports.getNMonthsAgo = getNMonthsAgo;
var getNDaysAgo = function (n) {
    var date = new Date();
    date.setDate(date.getDate() - n);
    return date;
};
exports.getNDaysAgo = getNDaysAgo;
/** Parse a "YYYY-MM-DD" string into midnight **local time** (not UTC). */
var parseLocalDate = function (value) {
    var _a = value.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    return new Date(y, m - 1, d);
};
exports.parseLocalDate = parseLocalDate;
/**
 * Build the end-of-interval Date for an export:
 * - if the date is today → return now (current instant)
 * - if the date is in the past → return 23:59:59.999 of that day in local time
 */
var toEndOfInterval = function (date) {
    var now = new Date();
    var isToday = date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();
    if (isToday)
        return now;
    var end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end;
};
exports.toEndOfInterval = toEndOfInterval;
/**
 *
 * indifferentemente dal tipo che invia il backend, questa funzione restituirà una stringa corrispettiva al finishType
 */
var mapBackendFinishAttributeToInternal = function (input) {
    if (input === null || input === undefined) {
        return constants_1.FINISH_TYPE_LABELS.REGULAR;
    }
    // Case 1: input is a number (e.g., 1)
    if (typeof input === 'number') {
        return constants_1.FINISH_TYPES_CONVERSIONS.find(function (entry) { return entry.code === input; }).label;
    }
    // Case 2: input is already a correct internal attribute (e.g., 'isFoil')
    if (typeof input === 'string') {
        return constants_1.FINISH_TYPES_CONVERSIONS.find(function (entry) { return entry.label === input; }).label;
    }
    // Case 3: input is a backend style string (e.g., 'foil') → find the matching internal attribute
    // const normalized = Object.entries(ATTRIBUTE_TO_FINISH_TYPE).find(
    //   ([key]) => key.toLowerCase().replace(/^is/, '') === input.toString().toLowerCase()
    // )
    return constants_1.FINISH_TYPE_LABELS.REGULAR;
    // return normalized?.[0] ?? (input as string) // fallback: return original input if no match
};
exports.mapBackendFinishAttributeToInternal = mapBackendFinishAttributeToInternal;
/**
 *
 * indifferentemente dal tipo che invia il backend, questa funzione restituirà un CountryEdition
 */
var mapBackendCountryEditionToInternal = function (input) {
    if (input === null || input === undefined) {
        return constants_1.CountryEdition.Regular;
    }
    // Match diretto su number code (es. 0, 1)
    if (typeof input === 'number')
        return constants_1.countryEditionMap.find(function (entry) { return entry.code === input; }).value;
    else
        return constants_1.countryEditionMap.find(function (entry) { return entry.label.toLowerCase() === input.toString().toLowerCase(); }).value;
};
exports.mapBackendCountryEditionToInternal = mapBackendCountryEditionToInternal;
var getFinishTypeNumber = function (isFoil, isRainbowFoil, isColdFoil, isReverseHolo) {
    if (isFoil)
        return constants_1.FINISH_TYPES.FOIL;
    if (isRainbowFoil)
        return constants_1.FINISH_TYPES.RAINBOW_FOIL;
    if (isColdFoil)
        return constants_1.FINISH_TYPES.COLD_FOIL;
    if (isReverseHolo)
        return constants_1.FINISH_TYPES.REVERSE_HOLO;
    return constants_1.FINISH_TYPES.REGULAR;
};
exports.getFinishTypeNumber = getFinishTypeNumber;
/**
 *
 * used to convert CM's unstructured finish types to internal finish types
 */
var getFinishTypeString = function (isFoil, isRainbowFoil, isColdFoil, isReverseHolo) {
    if (isFoil)
        return constants_1.FINISH_TYPE_LABELS.FOIL;
    if (isRainbowFoil)
        return constants_1.FINISH_TYPE_LABELS.RAINBOW_FOIL;
    if (isColdFoil)
        return constants_1.FINISH_TYPE_LABELS.COLD_FOIL;
    if (isReverseHolo)
        return constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO;
    return constants_1.FINISH_TYPE_LABELS.REGULAR;
};
exports.getFinishTypeString = getFinishTypeString;
var americanCountryEditionMatchingKeywords = ['american', 'us version', 'us edition'];
var americanCountryEditionKeywordsToReplace = [
    'american version',
    'american edition',
    'american print',
    'us version',
    'us edition',
];
/**
 * Cardmarket listings have no country edition field: the sync recognizes an American version from the comment
 * text alone (the unstructured fallback below, mirrored by CommentService on the Rails side). True when a comment
 * would trigger that reading, so we can warn before it is written on cards that are not US Edition — the sync
 * would then look for a listing that does not exist and silently stop updating them.
 */
var commentSuggestsUsEdition = function (comment) {
    return americanCountryEditionMatchingKeywords.some(function (keyword) {
        return (comment !== null && comment !== void 0 ? comment : '').toLocaleLowerCase().includes(keyword);
    });
};
exports.commentSuggestsUsEdition = commentSuggestsUsEdition;
/**
 * Every way a seller names a grading company in free text, mapped onto the canonical code.
 *
 * The code is the first of them. On top of it comes the company's own name, but only when that name is one word:
 * "AiGrading" is one a seller types, while a descriptive one like "Beckett Grading Services" is not, and hunting
 * for its words would drag in every comment that merely mentions grading. A capital inside that one word marks
 * where a seller puts a space back, so "Ai Grading" names the company too.
 *
 * Mirrors CommentService.company_name_spellings on the Rails side.
 */
// The names sellers write instead of the code we store. Only a word that names the company on its own belongs
// here: "Beckett" does, "Grading Services" does not, and neither does the first word of most of these labels —
// GRAAD registers as "Grade Authority and Authentication Division", and "grade" is in every graded comment ever
// written. Mirrors Rails CommentService::COMPANY_EXTRA_SPELLINGS.
var GRADING_COMPANY_EXTRA_SPELLINGS = { BGS: ['Beckett'] };
var GRADING_COMPANY_FREE_TEXT_NAMES = constants_1.GRADING_COMPANY_LABELS.flatMap(function (_a) {
    var _b;
    var label = _a.label, code = _a.code;
    var spellings = new Set(__spreadArray([code], ((_b = GRADING_COMPANY_EXTRA_SPELLINGS[code]) !== null && _b !== void 0 ? _b : []), true));
    if (label !== code && !/\s/.test(label)) {
        spellings.add(label);
        spellings.add(label.replace(/(?<=[a-z])(?=[A-Z])/g, ' '));
    }
    return Array.from(spellings).map(function (name) { return ({ name: name, code: code }); });
});
/**
 * Names the grading company mentioned in free text ("PSA 10", "psa 10", "Graad 8,5/9"), returning the code the
 * way GRADING_COMPANY_LABELS spells it rather than the way the seller typed it. The grade is deliberately not
 * read: a hand-written comment is not our normalized format, so the card is onboarded without a grade and the
 * user is the one who fills it in.
 *
 * Matched on whole words only. Reading a company out of a plain substring used to turn "PSA 10 grace" into an ACE
 * card, because "grace" contains "ace" — and an ACE 10 matches no pt_product_grading a PSA card ever has. When a
 * comment somehow names two companies, the one written first wins.
 *
 * A code that is also an ordinary word needs a number in the 0..10 range somewhere in the comment before it counts
 * as a company at all: "Rescue ACE" is a Yu-Gi-Oh archetype, "Ace Trainer" and "ACE SPEC" are Pokemon, Ace is a
 * One Piece character. Without that, cards nobody ever graded reach the graded-stock funnel and the seller is
 * asked for a grade that does not exist. Rails refuses them the same way, and the two have to agree: a card the
 * seller confirms as graded here and Rails reads as ungraded stops matching its own listing.
 */
// A designation specific enough to name a graded card with no number written beside it. Gem Mint is left out on
// purpose: every seller calls a nice card gem mint, so on its own it is praise rather than a grade.
var SELF_EVIDENT_DESIGNATIONS = ['pristine', 'black label', 'gold label'];
// Mirrors Rails read_grade_near: after the company a number needs no space in front of it, so "PSA10" and the
// "PRI10" of a real "CGC PRI10 | BLACK LABEL" both count; before it, the number has to stand on its own, so the
// "Box9" of a shelf name does not. 0 to 10 with one decimal is the range, the same one the table accepts.
var namesAGradeNumber = function (text, standalone) {
    var pattern = standalone ? /(?<![\w.,])\d+(?:[.,]\d+)?(?![\w])/g : /\d+(?:[.,]\d+)?/g;
    var match = pattern.exec(text);
    while (match !== null) {
        var value = Number(match[0].replace(',', '.'));
        if (value >= 0 && value <= 10 && Math.round(value * 10) === value * 10)
            return true;
        match = pattern.exec(text);
    }
    return false;
};
var namesSelfEvidentDesignation = function (comment, code, admissibleGrades) {
    var _a;
    return ((_a = admissibleGrades === null || admissibleGrades === void 0 ? void 0 : admissibleGrades[code]) !== null && _a !== void 0 ? _a : []).some(function (grade) {
        var designation = grade.split(' ').slice(1).join(' ');
        if (!SELF_EVIDENT_DESIGNATIONS.includes(designation.toLocaleLowerCase().replace(/-/g, ' '))) {
            return false;
        }
        return new RegExp("\\b".concat(designation.replace(/-/g, '[\\s-]+'), "\\b"), 'i').test(comment);
    });
};
var findGradingCompanyInFreeText = function (comment, admissibleGrades) {
    // Bounded by letters rather than by word characters, so "grace" still hides no ACE while "PSA10" is a company
    // with its grade written against it.
    var spelledAs = function (name) { return new RegExp("(?<![a-zA-Z])".concat(name, "(?![a-zA-Z])"), 'i'); };
    var namedCompanies = GRADING_COMPANY_FREE_TEXT_NAMES.map(function (_a) {
        var name = _a.name, code = _a.code;
        return ({
            code: code,
            name: name,
            at: comment.search(spelledAs(name)),
        });
    }).filter(function (_a) {
        var at = _a.at;
        return at !== -1;
    });
    if (namedCompanies.length === 0)
        return undefined;
    var _a = namedCompanies.sort(function (a, b) { return a.at - b.at; })[0], code = _a.code, name = _a.name;
    // A company on its own names nothing. Sellers write one to say a card is worth grading ("PSA Kandidat"), or to
    // name the shelf it sits on ("Box9/CCC"): on the census that was 379 articles of cards nobody had graded. What
    // makes a card graded is the company AND something readable as its grade — a number where a grade can be, or a
    // designation only that company awards. Rails asks the same question and fills the grade in; here it stays with
    // the seller either way.
    var at = namedCompanies.find(function (candidate) { return candidate.code === code; }).at;
    var writtenAfter = comment.slice(at + name.length);
    var writtenBefore = comment.slice(0, at);
    if (namesAGradeNumber(writtenAfter, false) || namesAGradeNumber(writtenBefore, true))
        return code;
    return namesSelfEvidentDesignation(comment, code, admissibleGrades) ? code : undefined;
};
/**
 * THE GRAMMAR OF A COMMENT PREFIX WE WROTE OURSELVES, e.g. "[US Edition - PSA 10.0 - Masterball-Holo] free text".
 *
 * It is deliberately rigid, because matching it is the only proof that the comment is ours — and therefore the
 * only licence to trust every attribute we read out of it:
 *
 *   - the comment opens with "[" and the prefix is everything up to the first "]"
 *   - components inside are separated by PT_COMMENT_PREFIX_SEPARATOR
 *   - they appear in this order — country edition, then grading, then finish type — and every component present
 *     must be recognized. Each of them is optional, but none of them may move: parsePtCommentPrefix reads them
 *     in that sequence and its steps are the rule
 *   - country edition is the literal "US Edition"
 *   - grading is the company code in uppercase plus a normalized grade, always one decimal: "PSA 10.0", never
 *     "PSA 10". The grade may carry its label after the number ("BGS 10.0 Black Label"), and then the label is
 *     part of it. The code on its own ("PSA") is how we write a graded card whose grade we do not know
 *   - the finish type uses its own label convention ("Masterball-Holo"), and only Pokemon carries one
 *
 * Anything else is not ours: a component out of order, a lowercase code, a grade missing its decimal, or a
 * bracket the seller wrapped around free text out of habit. In that case the structured reading is discarded
 * WHOLE and the comment is re-read as free text, which can still recognize the country edition and the grading
 * company but never the grade.
 *
 * Rails holds the same grammar from the other end: CommentService.comment_prefix writes it,
 * CommentService.parse_pt_strucured_comment reads it back and reports fully_structured, and
 * lib/cardmarket_utils.rb drops to parse_non_structured_comment when that flag is false, exactly as here.
 * One asymmetry is intended: on a comment that is not ours Rails still reads the grade, while here the grade is
 * left undefined on purpose. Node always has a user in front of it, so the grade is asked rather than guessed —
 * see client CompleteDataInGradedCards.
 *
 * Both sides now ask the same question before calling a card graded: the company AND something readable as its
 * grade. A company on its own names a shelf or a hope ("Box9/CCC", "PSA Kandidat"), not a grading. What they do
 * with the answer still differs — Rails reads the value against pt_product_gradings and files anything the company
 * cannot award under Unknown, while here the value is left for the seller either way.
 */
var PT_COMMENT_PREFIX_SEPARATOR = ' - ';
var PT_COMMENT_PREFIX_US_EDITION = 'US Edition';
/**
 * The grade a graded card is filed under when we cannot tell which one it is. It is a row of its own in
 * pt_product_gradings, one per grading company, and it is where a value the company cannot award ends up —
 * which is what keeps the card graded, and in front of the seller, instead of losing it.
 *
 * Mirrors PtProductGrading::UNKNOWN_GRADE_VALUE on the Rails side; the two must stay identical.
 */
exports.UNKNOWN_GRADE_VALUE = 'Unknown';
/**
 * Brings a grade someone typed into the single shape everything else depends on: a number with exactly one decimal,
 * and — when the grade carries a designation — one hyphenated token after a single space. "10.0", "10.0 Black-Label".
 *
 * This exists because that shape is not a preference. The comment we write on a listing packs the grade into one
 * component ("[BGS 10.0 Black-Label]"), and reading it back means matching that component whole against the
 * company's grades. A grade stored as "10 Black Label" would be written into a comment nobody can take apart
 * again: the reader cannot tell where the grade ends and the seller's own words begin, and the card stops matching
 * its own listing. So the fixing happens here, before the value is saved, rather than being caught later.
 *
 * What gets fixed is only ever spelling, never meaning: a missing decimal, a comma for a dot, a trailing zero,
 * spaces for hyphens, casing. Anything that would require guessing at the grade itself — a second decimal, a
 * number no company awards, a designation with digits in it — comes back as a problem for the caller to report.
 *
 * Mirrors PtProductGrading::GRADE_WITH_LABEL_FORMAT and valid_standard_decimal_grade on the Rails side, which
 * refuse the same values from the other end.
 */
var normalizeScaleGrade = function (input) {
    var typed = input.trim().replace(/\s+/g, ' ');
    if (typed === '')
        return { problem: 'empty' };
    // Unknown is not a grade a company awards, it is where the sync files one it could not read. It is seeded per
    // company and offering it here would put "I don't know" in front of the seller.
    if (typed.toLowerCase() === exports.UNKNOWN_GRADE_VALUE.toLowerCase())
        return { problem: 'reserved' };
    var _a = typed.split(' '), number = _a[0], rest = _a.slice(1);
    if (!/^\d+([.,]\d+)?$/.test(number))
        return { problem: 'noNumber' };
    var value = Number(number.replace(',', '.'));
    if (value < 0 || value > 10)
        return { problem: 'outOfRange' };
    // A trailing zero is spelling ("10.00" is the same ten), a second meaningful decimal is not: rounding 9.55 would
    // be us deciding which grade they hold.
    var rounded = Math.round(value * 10) / 10;
    if (rounded !== value)
        return { problem: 'tooPrecise' };
    var asStored = rounded.toFixed(1);
    if (rest.length === 0)
        return { grade: asStored };
    // Sellers and staff alike write the designation with a space, a hyphen, or both; all of them mean one token.
    var words = rest.join('-').split('-').filter(Boolean);
    if (!words.every(function (word) { return /^[A-Za-z]+$/.test(word); }))
        return { problem: 'badDesignation' };
    var designation = words
        .map(function (word) { return word[0].toUpperCase() + word.slice(1).toLowerCase(); })
        .join('-');
    return { grade: "".concat(asStored, " ").concat(designation) };
};
exports.normalizeScaleGrade = normalizeScaleGrade;
// Company code exactly as we store it, normalized grade, and optionally what follows the number inside the same
// component, with no separator before it — either a finish type or the label the grade carries.
//
// Built from the company list rather than written out, so a company added there is recognized in the prefix we
// write ourselves. Spelled out, adding one left our own "[AOG 10.0 Gem-Mint]" reading as somebody's free text.
// Longest code first: alternation stops at its first hit.
var PT_COMMENT_PREFIX_GRADING_REGEX = new RegExp("^(".concat(constants_1.GRADING_COMPANY_LABELS.map(function (_a) {
    var code = _a.code;
    return code;
})
    .sort(function (a, b) { return b.length - a.length; })
    .join('|'), ")\\s(\\d{1,2}\\.\\d)(?:\\s+(.+))?$"));
var FINISH_TYPE_LABEL_VALUES = new Set(Object.values(constants_1.FINISH_TYPE_LABELS));
/**
 * A finish type as the prefix spells it ("Masterball-Holo"), or undefined when that text is not one. Recognizing a
 * finish type and storing it are separate concerns: only Pokemon carries one, but the component still has to be
 * recognized whatever the game, or the prefix would not count as ours.
 */
var readPtCommentPrefixFinishType = function (part) {
    if (part === undefined)
        return undefined;
    var label = part.replace(/-/g, '');
    if (!FINISH_TYPE_LABEL_VALUES.has(label) || label === constants_1.FINISH_TYPE_LABELS.REGULAR)
        return undefined;
    return label;
};
/**
 * Whether a company is known to award this grade. Having our shape is one thing and being a value the company
 * really awards is another: PSA jumps straight from 9 to 10, so "PSA 9.5" is shaped like ours and impossible.
 *
 * The scale comes from pt_product_gradings and is handed in by whoever already holds it — the client from
 * useGradingScale, the worker from Postgres — so this file needs neither a request nor a database.
 *
 * No scale at all, or a company the scale says nothing about, means there is nothing to check against, and what
 * to answer then is the caller's call — whenScaleIsMissing. A bare number says yes: refusing it would strip the
 * grade off every graded card while the scale is still on its way, and for good on a company nobody seeded. A
 * grade carrying a label says no: without the scale there is no telling a label from anything else a seller may
 * have typed there, and asking the user beats guessing.
 */
var isGradeAwardedBy = function (gradingCompanyCode, grade, admissibleGrades, whenScaleIsMissing) {
    var awarded = admissibleGrades === null || admissibleGrades === void 0 ? void 0 : admissibleGrades[gradingCompanyCode];
    if (awarded === undefined || awarded.length === 0)
        return whenScaleIsMissing;
    return awarded.includes(grade);
};
/**
 * Reads the inside of "[...]" as our grammar and returns the attributes it states, or undefined when the prefix is
 * not ours. Nothing comes back until the WHOLE prefix has been recognized, so a half-read prefix cannot leak into
 * the result — which is the whole point: "[PSA 10.0 - US Edition]" used to keep the grading while silently losing
 * the country edition that was sitting in the wrong slot.
 */
var parsePtCommentPrefix = function (prefix, idGame, admissibleGrades) {
    var _a;
    var parts = prefix
        .split(PT_COMMENT_PREFIX_SEPARATOR)
        .map(function (part) { return part.trim(); })
        .filter(Boolean);
    var countryEdition = constants_1.CountryEdition.Regular;
    var grading;
    var grade;
    var finishType;
    var consumed = 0;
    // 1) Country edition
    if (parts[consumed] === PT_COMMENT_PREFIX_US_EDITION) {
        countryEdition = constants_1.CountryEdition.US;
        consumed++;
    }
    // 2) Grading. What follows the number inside the same component is one of two things, and nothing about their
    //    shape tells them apart — "5.0 Masterball-Holo" is a finish type glued to the grade, "10.0 Black-Label" is
    //    the label the grade carries, and both read as a number, a space and a hyphenated word. So they are not
    //    told apart by shape at all:
    //
    //      - a finish type is a closed set, known without asking anyone, so it is tried first
    //      - otherwise the whole thing has to BE a grade the company awards, matched against the scale as one
    //        piece. That is also why the label is stored hyphenated: it keeps the grade a single unit to compare
    //
    //    Anything the scale does not confirm leaves the component unconsumed, and the prefix is then not ours at
    //    all: the user is asked rather than shown a value the inventory will not hold. With no scale to ask, only
    //    a bare number is read — a labelled grade goes to the user, which beats guessing at it.
    var gradingMatch = (_a = parts[consumed]) === null || _a === void 0 ? void 0 : _a.match(PT_COMMENT_PREFIX_GRADING_REGEX);
    if (gradingMatch) {
        var trailing = gradingMatch[3];
        var trailingFinishType = readPtCommentPrefixFinishType(trailing);
        var isLabelled = trailing !== undefined && trailingFinishType === undefined;
        var readGrade = isLabelled ? "".concat(gradingMatch[2], " ").concat(trailing) : gradingMatch[2];
        if (isGradeAwardedBy(gradingMatch[1], readGrade, admissibleGrades, !isLabelled)) {
            grading = gradingMatch[1];
            grade = readGrade;
            finishType = trailingFinishType;
            consumed++;
        }
    }
    // 2b) A company with no grade after it is ours too: it is what Rails writes for a card whose grade is Unknown,
    //     since CommentService.comment_prefix leaves the value out of the prefix entirely. There is nothing to read,
    //     so the card is graded and the grade goes to the seller.
    if (grading === undefined && parts[consumed] !== undefined) {
        var loneCompany = constants_1.GRADING_COMPANY_LABELS.find(function (_a) {
            var code = _a.code;
            return code.toLocaleLowerCase() === parts[consumed].toLocaleLowerCase();
        });
        if (loneCompany !== undefined) {
            grading = loneCompany.code;
            consumed++;
        }
    }
    // 3) Finish type as a component of its own
    var ownFinishType = readPtCommentPrefixFinishType(parts[consumed]);
    if (ownFinishType !== undefined) {
        finishType = ownFinishType;
        consumed++;
    }
    // Ours only if something was recognized and nothing was left unconsumed
    if (consumed === 0 || consumed !== parts.length)
        return undefined;
    return {
        countryEdition: countryEdition,
        grading: grading,
        grade: grade,
        finishType: idGame === 6 ? finishType : undefined,
    };
};
/**
 * A graded article is waiting for the user only when we know the grading company but not the grade — because the
 * comment never spelled it out our way ("PSA 10" is not a normalized grade) or because it was blanked out.
 * The onboarding "check graded items" step, the table of rows it shows and the sync dialog all decide on this
 * same question, so they all have to ask it the same way: when they disagree the step opens on an empty table
 * with nothing to fix.
 */
var needsGradeCompletion = function (article) {
    var _a;
    if (!article.gradingCompany)
        return false;
    return "".concat((_a = article.grade) !== null && _a !== void 0 ? _a : '').trim() === '';
};
exports.needsGradeCompletion = needsGradeCompletion;
var parsePtStructuredComment = function (input, idGame, admissibleGrades) {
    var parsedComment = {
        comment: input,
        countryEdition: constants_1.CountryEdition.Regular,
        grading: undefined,
        grade: undefined,
        finishType: undefined,
    };
    if (!input || input.trim() === '')
        return parsedComment;
    var trimmedComment = input.trim();
    // Try structured parsing ONLY if it starts with [...]
    var prefixMatch = trimmedComment.match(/^\[([^\]]+)\]\s*(.*)$/);
    if (prefixMatch) {
        var prefixProperties = parsePtCommentPrefix(prefixMatch[1].trim(), idGame, admissibleGrades);
        // The prefix is ours: trust every attribute in it and drop it from the comment
        if (prefixProperties !== undefined) {
            return __assign(__assign(__assign({}, parsedComment), prefixProperties), { comment: (prefixMatch[2] || '').trim() });
        }
        // Not ours, so nothing of it is kept and the comment falls through to the free-text pass below, the same way
        // Rails does when fully_structured is false. The grade stays undefined by design: the user is asked for it.
    }
    // Unstructured fallback (does not remove text from comment)
    // Check other keywords
    var containsAmericanKeyword = americanCountryEditionMatchingKeywords.some(function (keyword) {
        return trimmedComment.toLocaleLowerCase().includes(keyword);
    });
    if (containsAmericanKeyword) {
        // 3. if contains keywords, remove them
        var cleanedComment = trimmedComment;
        for (var _i = 0, americanCountryEditionKeywordsToReplace_1 = americanCountryEditionKeywordsToReplace; _i < americanCountryEditionKeywordsToReplace_1.length; _i++) {
            var keyword = americanCountryEditionKeywordsToReplace_1[_i];
            var regex = new RegExp(keyword, 'ig');
            cleanedComment = cleanedComment.replace(regex, '');
        }
        cleanedComment = cleanedComment.trim();
        parsedComment.comment = cleanedComment;
        parsedComment.countryEdition = constants_1.CountryEdition.US;
    }
    // The company can still be recognized in free text, and the card is then graded with the grade left for the
    // user to confirm — the asymmetry with Rails described above.
    var gradingCompanyCode = findGradingCompanyInFreeText(trimmedComment, admissibleGrades);
    if (gradingCompanyCode !== undefined) {
        parsedComment.comment = trimmedComment;
        parsedComment.grading = gradingCompanyCode;
    }
    return parsedComment;
};
exports.parsePtStructuredComment = parsePtStructuredComment;
var parsePokemonFinishType = function (input, isReverseHolo) {
    var _a;
    if (input === '') {
        if (isReverseHolo)
            return constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO;
        else
            return constants_1.FINISH_TYPE_LABELS.REGULAR;
    }
    var cleanedComment = input.trim();
    var lowerComment = cleanedComment.toLowerCase().replace(/_/g, '-');
    // search structured comment
    switch (true) {
        // --- Reverse before ---
        case /\breverse-stamped-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.REVERSE_STAMPED_HOLO;
        case /\breverse-ice-cracked-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.REVERSE_ICE_CRACKED_HOLO;
        case /\breverse-cosmos-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.REVERSE_COSMOS_HOLO;
        case /\breverse-masterball-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.REVERSE_MASTERBALL_HOLO;
        case /\breverse-pokeball-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.REVERSE_POKEBALL_HOLO;
        case /\bstamped-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.STAMPED_HOLO;
        case /\bice-cracked-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.ICE_CRACKED_HOLO;
        case /\bcosmos-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.COSMOS_HOLO;
        case /\bmasterball-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.MASTERBALL_HOLO;
        case /\bpokeball-holo\b/i.test(lowerComment):
            return constants_1.FINISH_TYPE_LABELS.POKEBALL_HOLO;
        default:
        // fallback
    }
    var _loop_1 = function (word) {
        if (FINISH_TYPE_LABEL_VALUES.has(word) && word !== constants_1.FINISH_TYPE_LABELS.REGULAR) {
            var selectedLabel = word;
            if (isReverseHolo && !word.startsWith('Reverse')) {
                var reverseLabel_1 = "Reverse".concat(word);
                var found = constants_1.FINISH_TYPES_CONVERSIONS.find(function (entry) { return entry.label === reverseLabel_1; });
                if (found)
                    selectedLabel = found.label;
            }
            return { value: selectedLabel };
        }
    };
    // check for PascalCase finish type labels (e.g. "ReverseIceCrackedHolo")
    for (var _i = 0, _b = cleanedComment.split(/\s+/); _i < _b.length; _i++) {
        var word = _b[_i];
        var state_1 = _loop_1(word);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    var finishTypeKeywordsMap = (_a = {},
        _a[constants_1.FINISH_TYPE_LABELS.STAMPED_HOLO] = ['stamped', 'holo with stamp', 'stamp'],
        _a[constants_1.FINISH_TYPE_LABELS.ICE_CRACKED_HOLO] = [
            'ice cracked',
            'icecracked',
            'cracked',
            'ice',
            'prismatic',
            'mosaique',
            'shatter',
            'shattered',
        ],
        _a[constants_1.FINISH_TYPE_LABELS.COSMOS_HOLO] = ['cosmos', 'cosmic', 'cosmo'],
        _a[constants_1.FINISH_TYPE_LABELS.MASTERBALL_HOLO] = ['masterball'],
        _a[constants_1.FINISH_TYPE_LABELS.POKEBALL_HOLO] = ['pokeball'],
        _a);
    for (var _c = 0, _d = Object.entries(finishTypeKeywordsMap); _c < _d.length; _c++) {
        var _e = _d[_c], label = _e[0], keywords = _e[1];
        var _loop_2 = function (keyword) {
            var regex = new RegExp("\\b".concat(keyword, "\\b"), 'i');
            if (regex.test(lowerComment)) {
                var selectedLabel = label;
                if (isReverseHolo) {
                    var reverseLabel_2 = "Reverse".concat(selectedLabel);
                    var found = constants_1.FINISH_TYPES_CONVERSIONS.find(function (entry) { return entry.label === reverseLabel_2; });
                    if (found) {
                        selectedLabel = found.label;
                    }
                    else {
                        selectedLabel = constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO;
                    }
                }
                return { value: selectedLabel };
            }
        };
        for (var _f = 0, _g = keywords; _f < _g.length; _f++) {
            var keyword = _g[_f];
            var state_2 = _loop_2(keyword);
            if (typeof state_2 === "object")
                return state_2.value;
        }
    }
    // no match found
    if (isReverseHolo)
        return constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO;
    return constants_1.FINISH_TYPE_LABELS.REGULAR;
};
exports.parsePokemonFinishType = parsePokemonFinishType;
// Other ways a seller names a game in a file name, on top of our short name and the Cardmarket one.
var GAME_FILE_NAME_ALIASES = {
    1: ['mtg', 'magicthegathering'],
    9: ['finalfantasy'],
    10: ['weiss'],
    13: ['dragonball', 'fusionworld'],
    18: ['optcg'],
    20: ['battlespirits'],
    21: ['starwars'],
};
// Names this short are only taken as a word of their own: inside a longer word they are chance.
var SHORT_GAME_NAME_LENGTH = 3;
// The game a stock CSV belongs to, read from its name however it is spelled (case, spaces, dashes and
// accents do not count): our exports carry it, the onboarding backup ones are named <idGame>.csv.
// Undefined when no game, or more than one, is named, and for generic accessories (-genericSealed, 99),
// which the CSV import has no game to read with.
var gameFromStockFileName = function (fileName) {
    // idGame 0 is the catch-all entry, not a Cardmarket game.
    var games = gameMetaData_1.gameMetaData.filter(function (_a) {
        var idGame = _a.idGame;
        return idGame !== 0;
    });
    var base = fileName
        .replace(/\.[^.]+$/, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    if (/^\d+$/.test(base))
        return games.find(function (_a) {
            var idGame = _a.idGame;
            return idGame === Number(base);
        });
    var words = base.split(/[^a-z0-9]+/);
    if (words.includes('genericsealed'))
        return undefined;
    var compact = words.join('');
    var named = games.filter(function (game) {
        var _a, _b;
        return __spreadArray([game.name, (_a = game.cardmarketName) !== null && _a !== void 0 ? _a : ''], ((_b = GAME_FILE_NAME_ALIASES[game.idGame]) !== null && _b !== void 0 ? _b : []), true).map(function (spelling) { return spelling.toLowerCase(); })
            .filter(Boolean)
            .some(function (spelling) {
            return spelling.length <= SHORT_GAME_NAME_LENGTH
                ? words.includes(spelling)
                : compact.includes(spelling);
        });
    });
    return named.length === 1 ? named[0] : undefined;
};
exports.gameFromStockFileName = gameFromStockFileName;
// Backoffice only, and on purpose not exported: a person reads the list it feeds, so it leans towards catching too
// much. It looks for what a graded card's comment tends to carry even from a company we do not know: grading words,
// a long certificate number (slashes included), a grade written the way graders write it, or the name of a grading
// company we do not handle (European ones mostly), as a word of its own.
var POSSIBLY_GRADED_COMMENT = [
    /\b(mgc|pg|pcc|ags|cosmic|get\s*graded|mtg\s*grade)\b/i,
    /\b(grade|graded|grading|gradata|gradato|gradate|slab|slabbed|cert|certificate|certified|serial|pop)\b/i,
    /(^|\D)\d{7,10}(?!\d)/,
    /\b(gem\s*-?\s*mint|gem\s*mt|mint|pristine|perfect)\s*\d{1,2}(\.5)?\b/i,
    /\b\d{1,2}(\.5)?\s*\/\s*10\b/,
    /\b\d\.5\b/,
];
/**
 * What in a user's Cardmarket stock would trip the move to v2, read the same way the onboarding reads it: the same
 * listing at more than one price (v2 keeps one price per listing), comments that turn a card into US Edition,
 * graded cards, comments naming a taxation scheme, and comments naming a finish: the Pokemon ones we read, plus
 * anything mentioning foil or holo in any game, which we may not read at all.
 */
var checkCardmarketStockForV2Migration = function (idGame, articles) {
    var recognizedFinishTypes = new Map();
    // The onboarding reads the Pokemon finish out of the comment unless the structured prefix already gave it, and
    // the finish is part of what makes two listings the same one: a stamped holo next to a plain copy is not a
    // listing with two prices. The prefix is already stripped from the comment here, so a comment that still names a
    // finish is a free-text one. Articles from a CSV import come with that finish already applied, Cardmarket ones
    // with only the reverse flag: reading the comment again covers both.
    var stock = 
    // Literal 6 (Pokemon), not IdGame.Pokemon: see emptyBuyStrategyBulkSettings above.
    idGame === 6
        ? articles.map(function (article) {
            var isReverseHolo = article.finishType.startsWith('Reverse');
            var finishType = (0, exports.parsePokemonFinishType)(article.comment, isReverseHolo);
            if (finishType === (0, exports.parsePokemonFinishType)('', isReverseHolo))
                return article;
            var attributes = __spreadArray([], article.attributes, true);
            attributes[15] = finishType;
            var withFinish = new Article_1.InventoryArticle({ attributes: attributes, card: article.card });
            recognizedFinishTypes.set(withFinish, finishType);
            return withFinish;
        })
        : articles;
    var toRow = function (article) { return ({
        idArticle: article.idArticle,
        name: article.card.name,
        expansion: article.card.expansion,
        condition: article.condition,
        idLanguage: article.idLanguage,
        quantity: article.quantity,
        price: article.price,
        comment: article.comment,
        gradingCompany: article.gradingCompany,
        grade: article.grade,
        finishType: article.finishType,
    }); };
    return {
        multiplePrices: Object.values((0, exports.getPricesMapForeachInventoryArticle)(stock))
            .filter(function (entry) { return entry.prices.length > 1; })
            .map(function (entry) { return ({ prices: entry.prices, articles: entry.articles.map(toRow) }); }),
        usEdition: stock.filter(function (article) { return article.countryEdition === constants_1.CountryEdition.US; }).map(toRow),
        graded: stock.filter(function (article) { return !!article.gradingCompany; }).map(toRow),
        possiblyGraded: stock
            .filter(function (article) {
            return !article.gradingCompany &&
                POSSIBLY_GRADED_COMMENT.some(function (pattern) { var _a; return pattern.test((_a = article.comment) !== null && _a !== void 0 ? _a : ''); });
        })
            .map(toRow),
        taxation: stock.filter(function (article) { return (0, exports.commentSuggestsTaxation)(article.comment); }).map(toRow),
        finishType: stock
            .filter(function (article) { return recognizedFinishTypes.has(article) || /foil|holo/i.test(article.comment); })
            .map(function (article) { return (__assign(__assign({}, toRow(article)), { recognizedFinishType: recognizedFinishTypes.get(article) })); }),
    };
};
exports.checkCardmarketStockForV2Migration = checkCardmarketStockForV2Migration;
var getPtAttributesFromCardmarketArticleAttributes = function (cmArticle, idGame, admissibleGrades) {
    var _a = (0, exports.parsePtStructuredComment)(cmArticle[5], idGame, admissibleGrades), comment = _a.comment, countryEdition = _a.countryEdition, grading = _a.grading, grade = _a.grade, finishType = _a.finishType;
    return [
        cmArticle[0],
        cmArticle[1],
        cmArticle[2],
        cmArticle[3],
        cmArticle[4],
        comment,
        !!cmArticle[7],
        !!cmArticle[9],
        !!cmArticle[10],
        cmArticle[11],
        null,
        false,
        grading,
        grade,
        countryEdition,
        finishType !== null && finishType !== void 0 ? finishType : (0, exports.mapBackendFinishAttributeToInternal)((0, exports.getFinishTypeNumber)(!!cmArticle[6], false, false, !!cmArticle[8])),
        undefined, // ptArticleId
    ];
};
exports.getPtAttributesFromCardmarketArticleAttributes = getPtAttributesFromCardmarketArticleAttributes;
var getPtAttributesFromPlainCardmarketArticle = function (cmArticle) {
    var searchCountryEditionInComment = cmArticle.comments.toLocaleLowerCase();
    var countryEdition = constants_1.CountryEdition.Regular;
    if (searchCountryEditionInComment.includes('us') ||
        searchCountryEditionInComment.includes('american'))
        countryEdition = constants_1.CountryEdition.US;
    return [
        cmArticle.count,
        cmArticle.condition,
        cmArticle.language.idLanguage,
        cmArticle.idProduct,
        cmArticle.price,
        cmArticle.comments,
        cmArticle.isPlayset,
        cmArticle.isSigned,
        cmArticle.isFirstEd,
        cmArticle.idArticle,
        null,
        cmArticle.isAltered,
        undefined,
        undefined,
        countryEdition,
        (0, exports.mapBackendFinishAttributeToInternal)((0, exports.getFinishTypeNumber)(!!cmArticle.isFoil, false, false, !!cmArticle.isReverseHolo)),
        undefined, // ptArticleId
    ];
};
exports.getPtAttributesFromPlainCardmarketArticle = getPtAttributesFromPlainCardmarketArticle;
/**
 *
 * Returns the individual unstructured Boolean finish types. Mainly used to export the stock CSV file.
 */
var extractFinishTypeFlags = function (finishType) {
    return {
        isFoil: finishType === constants_1.FINISH_TYPE_LABELS.FOIL,
        isColdFoil: finishType === constants_1.FINISH_TYPE_LABELS.COLD_FOIL,
        isRainbowFoil: finishType === constants_1.FINISH_TYPE_LABELS.RAINBOW_FOIL,
        isReverseHolo: finishType === constants_1.FINISH_TYPE_LABELS.REVERSE_HOLO,
    };
};
exports.extractFinishTypeFlags = extractFinishTypeFlags;
var toSlimInventoryArticle = function (article) {
    var _a;
    var baseArticle = new Article_1.Article({ attributes: article.attributes });
    return {
        attributes: baseArticle.toPlainObject(),
        locations: (_a = article.locations) !== null && _a !== void 0 ? _a : [],
        comment: article.comment,
        newPrice: article.newPrice,
        newQuantity: article.newQuantity,
        newComment: article.newComment,
        newCondition: article.newCondition,
        newIdLanguage: article.newIdLanguage,
        buyPrice: article.buyPrice,
        buyPriceLock: article.buyPriceLock,
        taxationScheme: article.taxationScheme,
        purchaseEventId: article.purchaseEventId,
        standardTaxationQuantity: article.standardTaxationQuantity,
        marginTaxationQuantity: article.marginTaxationQuantity,
        newMarginTaxationQuantity: article.newMarginTaxationQuantity,
        newStandardTaxationQuantity: article.newStandardTaxationQuantity,
    };
};
exports.toSlimInventoryArticle = toSlimInventoryArticle;
function toSlimInventoryArticleList(articles) {
    return articles.map(exports.toSlimInventoryArticle);
}
exports.toSlimInventoryArticleList = toSlimInventoryArticleList;
var groupByPtArticle = function (stock) {
    var _a, _b, _c;
    var map = new Map();
    for (var _i = 0, stock_1 = stock; _i < stock_1.length; _i++) {
        var article = stock_1[_i];
        var newArticle = article.copyWithNewId();
        var key = Number(newArticle.ptArticleId);
        if (!map.has(key)) {
            newArticle.locations = __spreadArray([], ((_a = article.locations) !== null && _a !== void 0 ? _a : []), true);
            map.set(key, newArticle);
        }
        else {
            var existing = map.get(key);
            existing.quantity += newArticle.quantity;
            (_b = existing.locations) === null || _b === void 0 ? void 0 : _b.push.apply(_b, ((_c = article.locations) !== null && _c !== void 0 ? _c : []));
        }
    }
    return map;
};
exports.groupByPtArticle = groupByPtArticle;
var getFilteredStockStatistics = function (stock) {
    var quantity = 0;
    var price = 0;
    var newPrice = 0;
    var newQuantity = 0;
    var buyPrice = 0;
    var reservedQuantity = new Map();
    // A grid row is not an article. With locations expanded the same article is one row per
    // location, the listing keeps a card added in two separate sessions as two rows, and the
    // locations panel can stage a split-off whose SKU matches a row already in the grid.
    // Keying on generateArticleKey — the same key handleChangeZoomLevel uses to collapse rows
    // into articles — keeps this figure stable whether locations are grouped or expanded.
    var articleKeys = new Set();
    stock.forEach(function (article) {
        var _a, _b;
        var rowQty = article.quantity;
        articleKeys.add((0, exports.generateArticleKey)(article));
        var unitPrice = Number((_a = article.price) !== null && _a !== void 0 ? _a : 0);
        var unitBuyPrice = Number((_b = article.buyPrice) !== null && _b !== void 0 ? _b : 0);
        quantity += rowQty;
        price += article.price * rowQty;
        buyPrice += unitBuyPrice * rowQty;
        var hasNewQ = article.newQuantity !== undefined && article.newQuantity !== null;
        var rowNewQty = hasNewQ ? Number(article.newQuantity) : rowQty;
        newQuantity += rowNewQty;
        var hasNewP = article.newPrice !== undefined && article.newPrice !== null;
        var unitNewPrice = hasNewP ? Number(article.newPrice) : unitPrice;
        newPrice += unitNewPrice * rowNewQty;
        if (article.ptArticleReservedQuantity && article.ptArticleReservedQuantity > 0)
            reservedQuantity.set(article.ptArticleId, {
                reservedQty: article.ptArticleReservedQuantity,
                unitPrice: unitPrice,
                unitNewPrice: unitNewPrice,
                unitBuyPrice: unitBuyPrice,
            });
    });
    reservedQuantity.forEach(function (_a, _articleId) {
        var reservedQty = _a.reservedQty, unitPrice = _a.unitPrice, unitNewPrice = _a.unitNewPrice, unitBuyPrice = _a.unitBuyPrice;
        quantity = quantity - reservedQty;
        newQuantity = newQuantity - reservedQty;
        price = price - unitPrice * reservedQty;
        newPrice = newPrice - unitNewPrice * reservedQty;
        buyPrice = buyPrice - unitBuyPrice * reservedQty;
    });
    return {
        price: (0, exports.roundTo2Decimals)(price),
        newPrice: (0, exports.roundTo2Decimals)(newPrice),
        buyPrice: (0, exports.roundTo2Decimals)(buyPrice),
        quantity: quantity,
        newQuantity: newQuantity,
        uniqueArticles: articleKeys.size,
    };
};
exports.getFilteredStockStatistics = getFilteredStockStatistics;
var toPurchaseEventPayload = function (f) {
    var quantity = f.quantity != null ? Number(f.quantity) : undefined;
    var price = f.price != null ? Number(f.price) : undefined;
    if (quantity != null && Number.isNaN(quantity))
        throw new Error('totalQuantity non numerico');
    if (price != null && Number.isNaN(price))
        throw new Error('totalPrice non numerico');
    return {
        lotNumber: f.lotNumber.trim(),
        quantity: quantity,
        price: price,
        purchaseDate: f.purchaseDate,
        withVat: f.withVat,
        currency: f.currency,
    };
};
exports.toPurchaseEventPayload = toPurchaseEventPayload;
var normalizeSeller = function (dto) { return ({
    id: Number(dto.id),
    name: dto.name,
    vatNumber: dto.vatNumber,
    addressLine1: dto.addressLine1,
    addressLine2: dto.addressLine2,
    city: dto.city,
    province: dto.province,
    zipCode: dto.zipCode,
    country: dto.country,
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
}); };
exports.normalizeSeller = normalizeSeller;
var normalizePurchaseEvent = function (dto) {
    var _a;
    return ({
        id: Number(dto.id),
        userId: dto.userId,
        lotNumber: dto.lotNumber,
        sellerId: dto.sellerId != null ? Number(dto.sellerId) : undefined,
        seller: dto.seller ? (0, exports.normalizeSeller)(dto.seller) : undefined,
        quantity: dto.quantity != null ? Number(dto.quantity) : undefined,
        price: dto.price != null ? Number(dto.price) : undefined,
        purchaseDate: new Date(dto.purchaseDate),
        withVat: dto.withVat,
        createdAt: new Date(dto.createdAt),
        updatedAt: new Date(dto.updatedAt),
        currency: dto.currency,
        purchases: dto.purchases ? dto.purchases.map(exports.normalizePurchase) : [],
        totalRegisteredPrice: dto.totalRegisteredPrice,
        totalRegisteredQuantity: dto.totalRegisteredQuantity,
        hasReceipt: (_a = dto.hasReceipt) !== null && _a !== void 0 ? _a : false,
    });
};
exports.normalizePurchaseEvent = normalizePurchaseEvent;
var normalizePurchase = function (dto) { return ({
    id: Number(dto.id),
    isVat: dto.isVat,
    price: Number(dto.price),
    quantity: Number(dto.quantity),
    ptProductId: Number(dto.ptProductId),
    ptProduct: dto.ptProduct,
    creationCause: Number(dto.creationCause),
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
    purchaseEventId: Number(dto.purchaseEventId),
    purchaseEvent: dto.purchaseEvent ? (0, exports.normalizePurchaseEvent)(dto.purchaseEvent) : undefined,
}); };
exports.normalizePurchase = normalizePurchase;
var normalizeCsvReportHistory = function (response) { return ({
    id: response.id,
    intervalEndDate: response.intervalEndDate,
    intervalStartDate: response.intervalStartDate,
    createdAt: response.createdAt,
    exportEndedAt: response.exportEndedAt,
    lastErrorAt: response.lastErrorAt,
    lastError: response.lastError,
    params: response.params,
}); };
exports.normalizeCsvReportHistory = normalizeCsvReportHistory;
function computeSubscriptionGaps(subscriptions) {
    /**
     * To calculate gaps, you must compare:
     * the end of a subscription, with the start of the next one in time.
     * This only works if the array is sorted:
     * from past → future
     */
    var sorted = __spreadArray([], subscriptions, true).sort(function (a, b) { return new Date(a.subscriptionStart).getTime() - new Date(b.subscriptionStart).getTime(); });
    var gaps = [];
    for (var i = 0; i < sorted.length - 1; i++) {
        var currentEnd = new Date(sorted[i].subscriptionEnd);
        var nextStart = new Date(sorted[i + 1].subscriptionStart);
        var diffMs = nextStart.getTime() - currentEnd.getTime();
        // gap from the 6th day onwards
        if (diffMs <= constants_1.DAYS_BEFORE_RENEWAL)
            continue;
        if (nextStart < constants_1.TAXATION_RELEASE_DATE)
            continue;
        var from = currentEnd < constants_1.TAXATION_RELEASE_DATE
            ? constants_1.TAXATION_RELEASE_DATE.toISOString()
            : sorted[i].subscriptionEnd;
        gaps.push({
            from: from,
            to: sorted[i + 1].subscriptionStart,
        });
    }
    return gaps;
}
exports.computeSubscriptionGaps = computeSubscriptionGaps;
var getIdentityKeyFromFields = function (fields) {
    var _a, _b, _c, _d, _e, _f;
    return [
        (_a = fields.condition) !== null && _a !== void 0 ? _a : '',
        (_b = fields.idLanguage) !== null && _b !== void 0 ? _b : '',
        (_c = fields.finishType) !== null && _c !== void 0 ? _c : '',
        fields.isSigned ? '1' : '0',
        fields.isFirstEd ? '1' : '0',
        (_d = fields.countryEdition) !== null && _d !== void 0 ? _d : '',
        (_e = fields.gradingCompany) !== null && _e !== void 0 ? _e : '',
        (_f = fields.grade) !== null && _f !== void 0 ? _f : '',
    ].join('|');
};
exports.getIdentityKeyFromFields = getIdentityKeyFromFields;
var getArticleIdentityKey = function (article) {
    return (0, exports.getIdentityKeyFromFields)({
        condition: article.condition,
        idLanguage: article.idLanguage,
        finishType: article.finishType,
        isSigned: article.isSigned,
        isFirstEd: article.isFirstEd,
        countryEdition: article.countryEdition,
        gradingCompany: article.gradingCompany,
        grade: article.grade,
    });
};
exports.getArticleIdentityKey = getArticleIdentityKey;
exports.baseXmlHeader = '<?xml version="1.0" encoding="UTF-8"?>';
exports.BulkDataExchangeRequestsOpening = "<BulkDataExchangeRequests>\n<Header>\n   <SiteID>#SITE_ID#</SiteID>\n   <Version>#VERSION#</Version>\n</Header>";
exports.BulkDataExchangeRequestsClosing = "</BulkDataExchangeRequests>";
exports.AddFixedPriceItemRequest = "\n<AddFixedPriceItemRequest xmlns=\"urn:ebay:apis:eBLBaseComponents\">\n   <ErrorLanguage>en_US</ErrorLanguage>\n   <Version>#VERSION#</Version>\n   <Item>\n      <Description>\n         <![CDATA[TEST NICHT KAUFEN]]>\n      </Description>\n      <Title>#TITLE#</Title>\n      <SKU>#SKU#</SKU>\n      <PrimaryCategory>\n         <CategoryID>183454</CategoryID>\n      </PrimaryCategory>\n      <VATDetails>\n         <VATPercent>19</VATPercent>\n      </VATDetails>\n      <StartPrice>#PRICE#</StartPrice>\n      <ConditionID>3000</ConditionID>\n      <Country>DE</Country>\n      <Currency>EUR</Currency>\n      <DispatchTimeMax>2</DispatchTimeMax>\n      <ListingDuration>GTC</ListingDuration>\n      <ListingType>FixedPriceItem</ListingType>\n      <PictureDetails>\n         <GalleryType>Gallery</GalleryType>\n         <PictureSource>Vendor</PictureSource>\n         <PictureURL>#PICTURE_URL#</PictureURL>\n      </PictureDetails>\n      <ItemSpecifics>\n         <NameValueList>\n            <Name>\n               <![CDATA[Spiel]]>\n            </Name>\n            <Value>\n               <![CDATA[Magic: The Gathering]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Edition]]>\n            </Name>\n            <Value>\n               <![CDATA[#EXPANSION_NAME#]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Kartenname]]>\n            </Name>\n            <Value>\n               <![CDATA[#CARD_NAME#]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Seltenheit]]>\n            </Name>\n            <Value>\n               <![CDATA[#RARITY#]]>\n            </Value>\n         </NameValueList>\n         <NameValueList>\n            <Name>\n               <![CDATA[Bewertet]]>\n            </Name>\n            <Value>\n               <![CDATA[9.5]]>\n            </Value>\n         </NameValueList>\n      </ItemSpecifics>\n      <PostalCode>14057</PostalCode>\n      <Location>Berlin</Location>\n      <PostCheckoutExperienceEnabled>true</PostCheckoutExperienceEnabled>\n      <Quantity>#QUANTITY#</Quantity>\n      <SellerProfiles>\n         <SellerReturnProfile>\n            <ReturnProfileName>Return</ReturnProfileName>\n            <SellerPaymentProfile>\n               <PaymentProfileName>Payment</PaymentProfileName>\n            </SellerPaymentProfile>\n         </SellerReturnProfile>\n         <SellerShippingProfile>\n            <ShippingProfileName>Shipping</ShippingProfileName>\n         </SellerShippingProfile>\n      </SellerProfiles>\n      <Site>Germany</Site>\n   </Item>\n  </AddFixedPriceItemRequest>";
exports.EndFixedPriceItemRequest = "<EndFixedPriceItemRequest xmlns=\"urn:ebay:apis:eBLBaseComponents\">\n    <SKU>#SKU#</SKU>\n    <EndingReason>NotAvailable</EndingReason>\n</EndFixedPriceItemRequest>";
exports.GetUserRequest = "\n<GetUserRequest xmlns=\"urn:ebay:apis:eBLBaseComponents\">\n</GetUserRequest>";
var isInventoryStale = function (dateStr, now) {
    if (now === void 0) { now = new Date(); }
    if (!dateStr)
        return true;
    var parsed = new Date(dateStr);
    if (isNaN(parsed.getTime()))
        return true;
    var threshold = new Date(now);
    threshold.setDate(threshold.getDate() - constants_1.FULL_FETCH_STALENESS_DAYS);
    return parsed < threshold;
};
exports.isInventoryStale = isInventoryStale;
//# sourceMappingURL=lib.js.map